module.exports = __webpack_public_path__ + "static/media/sah_cover.705fd481.jpeg";